import styled from "styled-components"
import { colors } from "../../lib/colors"
import { TransitionsAnim } from "./Animation"
const { popUpSlideDown, popUpSlideUp } = TransitionsAnim()

interface Notification_Styled_props {
  fadeOut?: boolean
  isError: boolean
  isAirdrop?: boolean
  // errorType?: boolean
  // showLoader?: boolean
}

export const NotificationWrapper = styled.div<Notification_Styled_props>`
  ${popUpSlideDown};
  ${(b: any) => (b.fadeOut ? popUpSlideUp : null)};
  text-transform: uppercase;
  display: flex;
  background: ${({ isError, isAirdrop }: any) =>
    isError ? colors.errorBackground : isAirdrop ? colors.winBoxBackground : colors.notificationBackground};
  color: ${({ isError, isAirdrop }: any) =>
    isError ? colors.errorText : isAirdrop ? colors.liveBetsGreen : colors.notificationText};
  position: absolute;
  bottom: ${({ isError }: any) => (isError ? "50%" : "50px")};
  left: 50%;
  transform: translate(-50%, 0);
  padding: 4px 10px;
  border-radius: 4.48px;
  width: max-content;
  text-align: center;
`
